module.exports = __webpack_public_path__ + "static/media/assessments_submitted.c5b878c5.svg";